import React from 'react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const paidToast = (d) => ({ sent: 'marked paid. Confirmation emailed to the customer.', failed: 'marked paid, but the confirmation email failed to send. Please contact the customer.', no_email: 'marked paid. No email on file, so no confirmation was sent.', already_paid: 'was already marked paid. No email sent again.' }[d?.email_status] || 'marked paid.');

// verified = owner marked paid; claimed = customer says paid (not checked yet); unpaid = nothing.
export const depositState = (b) => (b.deposit_verified || b.deposit_marked_paid ? 'verified' : b.deposit_claimed_at ? 'claimed' : 'unpaid');

const norm = (v) => (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

export const DepositProof = ({ item }) => {
  const urls = item.deposit_proof_urls || [];
  if (!item.deposit_reference && !urls.length) return null;
  const match = norm(item.deposit_reference) === norm(item.expected_reference);
  return (
    <div className="mt-2 rounded-md border border-slate-200 bg-slate-50 p-2 text-xs" data-testid={`deposit-proof-${item.ref}`}>
      <div className="font-black uppercase tracking-wider text-[10px] text-slate-500">Customer payment details · check in Tide</div>
      <div className="mt-1 grid grid-cols-2 gap-2">
        <div><div className="text-slate-500">Reference we gave</div><div className="font-mono font-bold text-[color:var(--mv-navy)]">{item.expected_reference}</div></div>
        <div><div className="text-slate-500">Reference they used</div><div className="font-mono font-bold text-[color:var(--mv-navy)]" data-testid={`deposit-ref-used-${item.ref}`}>{item.deposit_reference || '—'}</div></div>
      </div>
      {item.deposit_reference && !match && <div className="mt-1 text-amber-800 font-semibold">Different from the reference we gave. Search Tide for the one they used.</div>}
      {urls.length > 0 && (
        <div className="mt-2 flex gap-2 flex-wrap">
          {urls.map((u, i) => (
            <a key={u} href={`${BACKEND}${u}`} target="_blank" rel="noreferrer" data-testid={`deposit-screenshot-${item.ref}-${i}`}>
              <img src={`${BACKEND}${u}`} alt={`Payment screenshot ${i + 1}`} className="h-20 w-20 object-cover rounded border border-slate-200" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export const DepositCheckRow = ({ item, onMarkPaid, onView }) => {
  const b = item.booking;
  return (
    <div className="rounded-lg border border-amber-200 bg-white p-3" data-testid={`deposit-check-${item.ref}`}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="font-bold text-[color:var(--mv-navy)]">{item.name} <span className="text-[10px] font-black text-slate-400">#{item.ref}</span></div>
          <div className="text-xs text-slate-500">
            {item.phone} · Deposit <strong className="text-[color:var(--mv-navy)]">£{item.deposit}</strong> · {b ? `Booked ${b.date} ${b.time}` : 'No slot yet'}
            {item.deposit_claimed_at && ` · Said paid ${new Date(item.deposit_claimed_at).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' })}`}
          </div>
        </div>
        <div className="flex gap-2">
          <button type="button" onClick={() => onView(item)} className="h-8 px-3 rounded-md border border-slate-200 text-xs font-bold text-[color:var(--mv-navy)]" data-testid={`deposit-check-view-${item.ref}`}>View</button>
          <button type="button" onClick={() => window.confirm(`Have you found £${item.deposit} with reference "${item.deposit_reference || '—'}" in Tide? This emails the customer.`) && onMarkPaid(item)} className="h-8 px-3 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold" data-testid={`deposit-check-paid-${item.ref}`}>Checked in Tide · mark paid</button>
        </div>
      </div>
      <DepositProof item={item} />
      {!item.deposit_reference && !(item.deposit_proof_urls || []).length && <div className="mt-2 text-xs text-slate-500">No reference or screenshot given (older booking).</div>}
    </div>
  );
};
